 import React from "react";
import { inject } from "mobx-react";
import { Dropdown, MenuItem, Glyphicon } from "react-bootstrap";
import { injectIntl, intlShape } from "react-intl";
import LaneStore from "./stores/LaneStore";

@inject("rootStore")
class MoveToLaneDropdown extends React.Component {
  constructor(props) {
    super(props);

    this.canEdit = props.rootStore.authorizationStore.canUpdate;
  }

  render() {
    const { note, intl } = this.props;

    return (
      <Dropdown
        onClick={this.handleClick}
        pullRight={true}
        id="change-lane-dropdown"
      >
        <Dropdown.Toggle noCaret={true}>
          <Glyphicon glyph="share-alt" />
        </Dropdown.Toggle>
        <Dropdown.Menu>
          <MenuItem header>
            {intl.formatMessage({ id: "move_to_dropdown_header" })}
          </MenuItem>
          {note.laneStore.rootStore.lanes.map(lane => (
            <MenuItem
              key={lane.id}
              eventKey={lane}
              onClick={this.handleClick}
              onSelect={this.handleSelect}
              disabled={note.laneStore.id === lane.id || !this.canEdit}
            >
              {intl.formatMessage({
                id: lane.rootStore.boardType + "-" + lane.name
              })}
            </MenuItem>
          ))}
        </Dropdown.Menu>
      </Dropdown>
    );
  }

  handleSelect = (lane, e) => {
    lane.moveNoteFromDropdown(this.props.note);
  };

  // Avoid the parent note listening to the click event
  handleClick(e) {
    e.stopPropagation();
  }

  // isMenuItemDisabled = (laneId) => {
  //     return this.props.note.listId === laneId;
  // };
}

export default injectIntl(MoveToLaneDropdown);
